import { CateringTranslations } from "./catering-pt-br";

export const CATERING_ES_MX: CateringTranslations = {
	title: "Catering",
	description:
		"Gestiona el catering de tus eventos, recibe propuestas, envía cotizaciones y monitorea todo en un solo lugar.",
};
